import {useState, useEffect, useCallback} from 'react'
import useDebounce from '../../context/hooks/useDebounce';
import { useNavigate } from 'react-router-dom';
import useAxiosPrivate from '../../context/hooks/useAxiosPrivate';
import {Table, Spinner, Form, ButtonGroup, ToggleButton, Row, Col} from 'react-bootstrap';
import ListPaginator from '../../components/ListPaginator';
import ExcelTracking from '../../components/ExcelTracking';
import '../../appstyles/ClientsCSS/ClientsList.css';
import PermissionWrapper from '../../context/PermissionWrapper';

function TrackingList() {
  const axiosInstance = useAxiosPrivate();
  const [orders, setOrders] = useState([]);
  const [status, setStatus] = useState(true);
  const [loading, setLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState('');
  const debouncedSearch = useDebounce(search, 700);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const navigate = useNavigate();

  const fetchOrders = useCallback((page, searchQuery, pageSize) => {
    setLoading(true);
    const url = searchQuery
      ? `api/logistics-tracking/?page=${page}&size=${pageSize}&status=Cerrado&exclude=${status}&search=${searchQuery}`
      : `api/logistics-tracking/?page=${page}&size=${pageSize}&status=Cerrado&exclude=${status}`;

    axiosInstance.get(url)
      .then(response => {
        setOrders(response.data);
        setTotalPages(response.data.totalPages);
      })
      .catch(error => {
        console.log('Failed to fetch orders', error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [axiosInstance, status]);

  const handleFilterChange = (event) => {
    setStatus(event.target.value === 'true');
  };

  const radios = [
    { name: 'Abierto', value: 'true' },
    { name: 'Cerrado', value: 'false' }
  ];

  useEffect(() => {
      fetchOrders(currentPage, debouncedSearch, rowsPerPage);
    }, [currentPage, debouncedSearch, status, rowsPerPage, fetchOrders]);

  const handleRowClick = (trackId) => {
        navigate(`/traceability/${trackId}`);
  };

  const handlePageChange = (pageNumber) => {
      setCurrentPage(pageNumber);
  }; 


  const getStatusColor = (status) => {
    switch (status) {
      case 'A tiempo':
        return 'green';
      case 'Retraso':
        return 'red';
      case 'Advertencia':
        return 'orange';
      default:
        return 'black';
    }
  };

  return (
    <div className='maestros-list'>
    <h2>Trazabilidad Ordenes de Compra</h2>
    <hr />
    <Form.Control
      style={{ width: '50%' }}
      type="search"
      placeholder="Buscar por cliente, proveedor, ID o consecutivo cliente"            
      value={search}
      onChange={(e) => setSearch(e.target.value)}
    >
    </Form.Control>

  <ButtonGroup toggle style={{width: '20%'}}>
    {radios.map((radio, idx) => (
      <ToggleButton
        key={idx}
        id={`radio-${idx}`}
        type="radio"
        variant={idx % 2 ? 'outline-secondary' : 'outline-secondary'}
        name="radio"
        value={radio.value}
        checked={status.toString() === radio.value}
        onChange={(e) => handleFilterChange(e)}
    >
        {radio.name}
      </ToggleButton>
        ))}
  </ButtonGroup>


    {loading ? ( 
      <div className='loading-container'>
      <p style={{fontFamily: 'Roboto, sans-serif'}}>Cargando...</p>
      <Spinner animation="border" variant="info" style={{width: '4.5rem', height: '4.5rem'}} />
      </div>
    ) : (  
    <Table striped bordered hover responsive
      style={{overflowY: 'auto'}}
    >
        <thead>
          <tr>
              <th>ID</th>
              <th>Cliente</th>
              <th style={{ minWidth: '150px' }}>Producto</th>
              <th>Fabricante</th>
              <th>Estado</th>
              <th style={{ minWidth: '150px' }}>Consecutivo Cliente</th>
              <th style={{ minWidth: '150px' }}>Consecutivo Proveedor</th>
              <th style={{ minWidth: '100px' }}>Alerta</th>
          </tr>
        </thead>
        <tbody>
          {orders.data && orders.data.map(order => (
            <tr key={order.tracking_id} onClick={() => handleRowClick(order.tracking_id)} style={{ cursor: 'pointer' }}>
                <td>{order.quote_id}</td>
                <td>{order.quote_details.client_name}</td>
                <td style={{ minWidth: '150px' }}>{order.quote_details.product_names}</td>
                <td>{order.quote_details.product_manufacturers}</td>
                <td>{order.status}</td>
                <td style={{ minWidth: '150px' }}>{order.quote_details.client_consecutive ? order.quote_details.client_consecutive : 'N/A'}</td>
                <td style={{ minWidth: '150px' }}>{order.supplier_consecutive ? order.supplier_consecutive : 'N/A'}</td>
                <td style={{ 
                  minWidth: '100px',  
                  color: getStatusColor(order.deadline_status),
                  fontWeight: 'bold'
                }}>
                  {order.deadline_status}
                </td>
            </tr>
          ))}
        </tbody>
    </Table>
    )}
    <Row style={{ alignItems: 'center', marginTop: '1.5rem' }}>
      <Col md={6} style={{ display: 'flex', alignItems: 'center' }}>
        <PermissionWrapper feature="trazabilidad" action="excel">
          <ExcelTracking />
        </PermissionWrapper>
      </Col>
      <Col md={6} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
        <ListPaginator
          currentPage={currentPage}
          totalPages={totalPages}
          rowsPerPage={rowsPerPage}
          onPageChange={handlePageChange}
          onRowsPerPageChange={value => {
            setRowsPerPage(value);
            setCurrentPage(1);
          }}
        />
      </Col>
    </Row>
    </div>
  )
}

export default TrackingList